import { render } from 'preact-render-to-string';
import { BasicEmailWrapper, Heading, Line, SupportFooter } from './shared';

export type DeferredEnrollmentConfirmationProps = {
  courseTitle: string;
  enrollmentDate: string;
  replyTo?: string;
};

export function DeferredEnrollmentConfirmation(props: DeferredEnrollmentConfirmationProps) {
  return render(
    <BasicEmailWrapper footer={<SupportFooter email={props.replyTo} />}>
      <Heading>You're in!</Heading>
      <Line>
        You've been added to <strong>{props.courseTitle}</strong>. Your access begins on{' '}
        <strong>{props.enrollmentDate}</strong>.
      </Line>
      <Line>We'll send you an email when it's time to get started.</Line>
      <Line>
        In the meantime, keep an eye on your inbox — we'll have everything ready for you on your
        enrollment date.
      </Line>
    </BasicEmailWrapper>,
  );
}
